import * as React from 'react';
import {observer} from "mobx-react-lite";
import {IP} from "../../models/stats";
import {WorstIpStore} from "../../stores/stats";
import {Carousel, Col, Row} from "react-bootstrap";
import { Link } from 'react-router-dom';
import Backdrop from "../Backdrop";


const WorstIp = observer(function WorstIp(props: {
    store: WorstIpStore
}) {
    const {store} = props
    return <>
        {store.error ? store.error : ''}
        <Backdrop hidden={!store.loading} />

                <Carousel.Caption>
            <h3>Worst IPs</h3>
            <p>IP addresses tied to the most threats</p>
        </Carousel.Caption>

        <WorstIpList items={store.data.slice(0, 10)}/>
    </>
});

const WorstIpList = observer(function WorstIpList(props: { items: IP[] }) {
    return <div className="stats-data justify-content-around">
        {props.items.map((e) => <WorstIpView item={e} key={e.id}/>)}
    </div>
})

const WorstIpView = observer(function WorstIpView(props: { item: IP }) {
    const {item} = props
    return <Row>
        <Col className="text-right"><Link to={"/ioc/"+item.ip}>{item.ip}</Link></Col>
        <Col className="text-left">{item.country}</Col>
    </Row>
})

export default WorstIp